import { Button } from '@material-ui/core';
import { useEffect, useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { getTemplateClusterlets } from "../../../../store/constructs/templated_clusterlet/selectors";
import { useSelector, useDispatch } from 'react-redux';
import { addTemplateTransaction } from "../../../../store/constructs/transactions/actions";
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { updateFullHandlers } from "../../../../store/constructs/handlers/actions";
import { reRenderInfoBuilder } from "../../../../store/global/actions";
import { StyledTableCell, StyledTableRow } from '../../../atoms/table/tableStyles';
import { handleSnackBar } from "../../../../store/global/actions";
import { setHandler } from '../../../../services/blueprint.js';
const shortUUiD = require("short-uuid");



export default function TemplateTransactionSelector({ handleClose, currentTransaction, transactionYPosition }) {
    const dispatch = useDispatch();
    const [templateSelected, setTemplateSelected] = useState(null);
    const templateList = useSelector(getTemplateClusterlets);
    const templateClusterletsInTransaction = currentTransaction.clusterlets?.filter((item) => item.category === 'templateClusterlet')?.map(item => item.id);
    const filteredTemplateList = templateList.filter(template => templateClusterletsInTransaction.includes(template.id));
    const [templateTransactions, setTemplateTransactions] = useState({});
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [value, setValue] = useState(null);

    const onSave = async () => {
        const selectedTransactionObj = templateTransactions[selectedTransaction];
        const selectedTemplate = filteredTemplateList.find(template => template.id == templateSelected);
        const userdefinedClusterlets = currentTransaction.clusterlets?.filter((item) => item.category === 'userdefined')?.map(item => item.id);
        if (templateSelected === null) {
            dispatch(handleSnackBar({ open: true, message: `Please select a template`, severity: "error" }));
            return;
        }
        if (selectedTransaction === null) {
            dispatch(handleSnackBar({ open: true, message: `Please select a transaction`, severity: "error" }));
            return;
        }

        const invokeId = shortUUiD.generate();

        const handlers = await setHandler(selectedTransactionObj, selectedTemplate, userdefinedClusterlets, invokeId)

        dispatch(addTemplateTransaction({ name: selectedTransaction, order: transactionYPosition, templateId: templateSelected, type: 24, invokeId  }, currentTransaction.id, handlers));
        
        dispatch(updateFullHandlers(handlers));
        handleClose();
        dispatch(reRenderInfoBuilder())

    }

    const handleChange = (event) => {
        setSelectedTransaction(event.target.value)
        setValue(event.target.value)
    }

    useEffect(() => {
        if (templateSelected !== null) {
            let transactions = filteredTemplateList.find(template => template.id == templateSelected).metajson.callflowdefs;
            for (const item in transactions) {
                transactions[item].eventNames = transactions[item].children.filter(item => item.type === 'sendmsg').map(item => item.name);
                transactions[item].callflowNames = transactions[item].children.filter(item => item.type === 'callflow').map(item => item.name);
            }

            setTemplateTransactions(transactions);
        }
    }, [templateSelected])

    

    return (

        <Grid container spacing={2} xs={12} style={{ paddingLeft: 10 }}>

            <Grid row xs={12} style={{ paddingBottom: 10 }}>
                <Select variant={'outlined'}
                    defaultValue='select'
                    style={{ width: 472 }} xs={12}
                    onChange={e => setTemplateSelected(e.target.value)}

                >
                    <MenuItem value='select'>Select the template</MenuItem>
                    {filteredTemplateList.map(template => <MenuItem value={template.id}>{template.name}</MenuItem>)}
                </Select>
            </Grid>

            {templateSelected !== null && <Grid row xs={12}>
                <RadioGroup value={value} onChange={handleChange}>

                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">

                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="center">Select</StyledTableCell>
                                    <StyledTableCell align="center">Transaction</StyledTableCell>
                                    <StyledTableCell align="center">Events</StyledTableCell>
                                    <StyledTableCell align="center">Invoked Transactions</StyledTableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Object.values(templateTransactions).map(callflow =>
                                    <StyledTableRow>
                                        <StyledTableCell align="center"> <FormControlLabel value={callflow.name} control={<Radio color="primary" />} /></StyledTableCell>
                                        <StyledTableCell align="center">{callflow.name}</StyledTableCell>
                                        <StyledTableCell align="center">{callflow.eventNames.map(item => <MenuItem value={item}>{item}</MenuItem>)}</StyledTableCell>
                                        <StyledTableCell align="center">{callflow.callflowNames.map(item => <MenuItem value={item}>{item}</MenuItem>)}</StyledTableCell>
                                    </StyledTableRow>
                                )}

                            </TableBody>
                        </Table>
                    </TableContainer>


                </RadioGroup>
            </Grid>}

            <Grid row xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>

                <Button onClick={handleClose} variant="contained" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button onClick={onSave} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                    Use
                </Button>

            </Grid>

        </Grid>
    )
}